module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n        Average blocksizes.\n    ")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('stat-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-blocksize"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-203a0eae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/blocksize.vue
// module id = 531
// module chunks = 1